import apiClient from './client';
import { limitReason, contentLimitReason } from '../utils/customerLimits';

export async function fetchCustomerLimits(params = {}) {
  const { data } = await apiClient.get('/customer-limits', { params, timeout: 15000 });
  if (!data || !Object.hasOwn(data, 'package') || !data.usage)
    throw new Error('Customer limits could not be loaded.');
  return data;
}

// Serialize additions within this admin tab, including separate upload/create controls.
let pending = Promise.resolve();
export function withCustomerLimit(params, kind, action, { amount = 1, checkContent = false } = {}) {
  const run = pending.then(async () => {
    let state;
    try { state = await fetchCustomerLimits(params); }
    catch { throw new Error('Customer limits could not be loaded. Please retry.'); }
    const reason = (kind ? limitReason(state, kind, amount) : '')
      || (checkContent ? contentLimitReason(state) : '');
    if (reason) throw new Error(reason);
    try { return await action(); }
    catch (error) {
      const data = error?.response?.data;
      const message = data?.message || data?.detail;
      if (message) error.message = message;
      throw error;
    }
    finally { window.dispatchEvent(new Event('customer-limits-changed')); }
  });
  pending = run.catch(() => {});
  return run;
}
